// extracted by mini-css-extract-plugin
module.exports = {"container":"Breadcrumbs_container__3h5FP","link":"Breadcrumbs_link__JZ-9r","selected":"Breadcrumbs_selected__NPC3y","arrow":"Breadcrumbs_arrow__2LMFD"};